import { render } from "./BagicCompanySelector.vue?vue&type=template&id=08d1d13e&scoped=true"
import script from "./BagicCompanySelector.vue?vue&type=script&lang=js"
export * from "./BagicCompanySelector.vue?vue&type=script&lang=js"

import "./BagicCompanySelector.vue?vue&type=style&index=0&id=08d1d13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d1d13e"]])

export default __exports__